const L = {
  name: "Backspace",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.9994 13.4142L11.9994 16.4142L10.5852 15L13.5852 12L10.5852 9L11.9994 7.58579L14.9994 10.5858L17.9994 7.58579L19.4136 9L16.4136 12L19.4136 15L17.9994 16.4142L14.9994 13.4142Z" fill="currentColor"/>
<path d="M5.60329 4.19492C6.16786 3.45207 7.04952 3 7.99945 3L20.9995 3C22.6517 3 23.9995 4.34772 23.9995 6L23.9995 18C23.9995 19.6523 22.6517 21 20.9995 21L7.99945 21C7.04952 21 6.16786 20.5479 5.60329 19.8051L5.59944 19.8L1.09945 13.8L1.0981 13.7982C0.303237 12.7334 0.303237 11.2666 1.0981 10.2018L1.09945 10.2L5.60329 4.19492ZM7.19724 5.40295L2.7008 11.3982C2.43643 11.753 2.43585 12.2461 2.70015 12.6009L2.7008 12.6018L7.19725 18.5971C7.39271 18.8529 7.69025 19 7.99945 19H20.9995C21.5472 19 21.9995 18.5477 21.9995 18V6C21.9995 5.45228 21.5472 5 20.9995 5L7.99945 5C7.69025 5 7.39271 5.14711 7.19724 5.40295Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as Backspace
};
